import { getBoxFolders, getUsersSearch, uploadFile } from '../../services/BoxService';
import {
  FOLDER_CONFIRMED_ACTION,
  FOLDER_FAILED_ACTION,
  OKTA_USER_SEARCH_CONFIRMED_ACTION,
  OKTA_USER_SEARCH_FAILED_ACTION,
  UPLOAD_CONFIRMED_ACTION,
  UPLOAD_FAILED_ACTION,
} from './actionTypes';

export function folderAction(id) {
  return (dispatch) => {
    getBoxFolders(id)
      .then((response) => {
        dispatch(confirmedFolderAction(response.data));
      })
      .catch((error) => {
        const errorMessage = error.response.data;
        dispatch(folderFailedAction(errorMessage));
      });
  };
}

export function uploadToBoxAction(pdf, id, formName = 'NULLED') {
  return (dispatch) => {
    uploadFile(pdf, formName, id)
      .then((response) => {
        dispatch(confirmedUploadAction(response.data));
      })
      .catch((error) => {
        const errorMessage = error.response.data;
        dispatch(uploadFailedAction(errorMessage));
      });
  };
}

export function employeeSearchAction(key) {
  return async (dispatch) => {
    await getUsersSearch(key)
      .then((response) => {
        dispatch(confirmedFolderAction(response.data));
      })
      .catch((error) => {
        const errorMessage = error.response.data;
        dispatch(folderFailedAction(errorMessage));
      });
  };
}

export function confirmedFolderAction(payload) {
  return {
    type: FOLDER_CONFIRMED_ACTION,
    payload,
  };
}

export function folderFailedAction(data) {
  return {
    type: FOLDER_FAILED_ACTION,
    payload: data,
  };
}

export function confirmedUploadAction(payload) {
  return {
    type: UPLOAD_CONFIRMED_ACTION,
    payload,
  };
}

export function uploadFailedAction(data) {
  return {
    type: UPLOAD_FAILED_ACTION,
    payload: data,
  };
}

export function confirmedEmployeeSearchAction(payload) {
  return {
    type: OKTA_USER_SEARCH_CONFIRMED_ACTION,
    payload,
  };
}

export function employeeSearchFailedAction(data) {
  return {
    type: OKTA_USER_SEARCH_FAILED_ACTION,
    payload: data,
  };
}
